import type { ClientListItem } from '@/entities/client';
export function sortClientsBySearchTerm(
    clients: ClientListItem[],
    searchTerm: string,
): ClientListItem[] {
    const searchLower = searchTerm.toLowerCase().trim();

    if (!searchLower) {
        return clients;
    }

    // No filtering: the reader already applied the same predicate, and repeating it here would
    // discard whatever the server newly matches once its matching widens.
    const rank = (client: ClientListItem) => {
        const name = client.name.toLowerCase();
        if (name.startsWith(searchLower)) return 0;
        if (name.includes(searchLower)) return 1;
        return 2;
    };

    return [...clients].sort((a, b) => rank(a) - rank(b));
}
